module.exports = "data:image/gif;base64,R0lGODlhIAAgAPMAAP///3x8fO6srPOqqvaoqfKzt/O0t8bGxs7OztHR0dra2t3d3ebm5ujo6PPz8////yH5BAEAAAAALAAAAAAgACAAAATfEMhJq7046827/2DoPWRZLotJYurjJEkgz7R8OKtFxnVPJ7hHw3FpHEgL30xR4tlKFOfxkQzcSAyH8hntpR4xhQyxlT26vceMHGDXjo0AbuKkqcfjBEM8S5ACAmcSdTMPBwELBWV+VAE5hGZVZQGMd00+dz6KNANpkI49BS+TMjCYew9sbqSmaYdteKSln5lsn0pgmDMLBrc0Bw0murIEdhN/NZkHDAyvM0dmZhQkzqABDDRJlQ/YpYLTcdGY3wBCByksWtYyDDzkH9QlaSISKuoyc/QVO4z6/v8AAwKIAAA7"


//////////////////
// WEBPACK FOOTER
// ./static/images/MapIcon/ambulance/CHeadNE_S7.gif
// module id = dpu+
// module chunks = 50